import React from "react";
import "./styles/home.css";
import Projects from "./Projects";
import { FaArrowRight } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import Education from "./Education";
import Experinece from "./Experience";
import { Certificates } from "./Certificates";
import Leetcode from "./LeetCode";
const Home = () => {
  return (
    <>
      <div className="flex flex-col md:flex-row justify-between">
        <div className=" md:w-3/4">
          <h1 className="font-bold text-3xl md:text-5xl tracking-tight mb-4 text-black dark:text-white">
            Hey, I'm
            <span className="text-purple-500"> Sahil Jena</span>
          </h1>
          <h2 className="text-gray-600 dark:text-gray-400 mb-4 mt-4 font-light tracking-wide leading-normal">
            I'm a 20 yrs
            <span className="dark:text-purple-500 font-bold">
              Full Stack Developer
            </span>
            from Delhi, India. I'm a <br />
            Pre-final year student in computer science engineering at{" "}
            <a
              className="text-black dark:text-sky-400 no-underline hover:underline"
              href="https://srmist.edu.in"
              target="_blank"
              rel="noreferrer"
            >
              SRMIST.
            </a>
            <br />I have a keen inetrest in web development and competetive
            programming.
            <br />
            <br />
            <span className="font-bold">My Skills Include</span>
            <br />
            <div className="flex flex-wrap justify-start gap-[10px] max-w-[90%]">
              <span className="text-sm px-2 py-0.5 text-white font-bold rounded-[12px] bg-gray-900">
                Flask
              </span>
              <span className="text-sm px-2 py-0.5 text-white font-bold rounded-[12px]  bg-sky-700">
                Python
              </span>
              <span className="text-sm px-2 py-0.5 text-green-400 font-bold rounded-[12px] bg-stone-900">
                MongoDB
              </span>
              <span className="text-sm px-2 py-0.5 text-sky-200 font-bold rounded-[12px] bg-sky-700">
                ReactJS
              </span>
              <span className="text-sm px-2 py-0.5 text-white font-bold rounded-[12px] bg-green-500">
                NodeJS
              </span>
              <span className="text-sm px-2 py-0.5 text-white font-bold rounded-[12px] bg-gray-900">
                C
              </span>
              <span className="text-sm px-2 py-0.5 text-white font-bold rounded-[12px] bg-stone-900">
                C++
              </span>
              <span className="text-sm px-2 py-0.5 text-white font-bold rounded-[12px] bg-orange-600">
                MySQL
              </span>
            </div>
          </h2>
        </div>
        <div className="md:flex hidden md:w-1/4 flex-col">
          <img
            src="https://i.ibb.co/syx2d3W/DSC0162-1.jpg"
            alt="Sahil Jena"
            className="rounded-full max-w-[200px] shadow-xl shadow-cyan-700/50"
          />
        </div>
      </div>
      <div>
        <Leetcode />
      </div>
      <div>
        <h3 className="font-bold text-2xl md:text-4xl tracking-tight mb-4 mt-8 text-black dark:text-white">
          Experience & Achivements
        </h3>
        <Experinece />
      </div>
      <div>
        <h3 className="font-bold text-2xl md:text-4xl tracking-tight mb-4 mt-8 text-black dark:text-white">
          Projects
        </h3>
        <Projects type="pre" />
        <NavLink
          exact
          to="/projects"
          className="flex underline decoration-dashed text-gray-600 dark:text-cyan-300"
        >
          more <FaArrowRight className="mt-[4.5px] mx-1" />
        </NavLink>
      </div>
      <div>
        <h3 className="font-bold text-2xl md:text-4xl tracking-tight mb-4 mt-8 text-black dark:text-white">
          Education
        </h3>
        <Education />
      </div>
      <div>
        <h3 className="font-bold text-2xl md:text-4xl tracking-tight mb-4 mt-8 text-black dark:text-white">
          Certificates
        </h3>
        <Certificates />
      </div>
    </>
  );
};

export default Home;
